// Code from https://codepen.io/labnol/pen/vYXYrOW
// Modified to use React hooks and TypeScript

import {ExternalVideo} from '@shopify/hydrogen/storefront-api-types';
import getYouTubeId from 'get-youtube-id';
import {Image} from '@shopify/hydrogen';
import YoutubeEmbed from '../YoutubeEmbed.client';
import iconPlay from '../../assets/icons/icon-play.svg';
import {DATA_TEST_IDS} from '~/lib/const';

export function ProductGalleryAssetYoutube({
  media,
  isThumbnail,
}: {
  media: ExternalVideo;
  isThumbnail?: boolean;
}) {
  const videoId = getYouTubeId(media.embedUrl);

  if (!videoId) {
    return null;
  }

  return (
    <div
      data-testid={DATA_TEST_IDS.YOUTUBE_PLAYER}
      className="h-full flex items-center"
    >
      {isThumbnail ? (
        <div>
          <Image
            loading="lazy"
            src={`https://i.ytimg.com/vi_webp/${videoId}/hqdefault.webp`}
            alt="Youtube Video"
            width="100%"
            height="100%"
          />
          {!isThumbnail && (
            <div className="play">
              <Image
                data-testid={DATA_TEST_IDS.ICON('play')}
                loading="lazy"
                src={iconPlay}
                alt="Play"
                width={72}
                height={72}
              />
            </div>
          )}
        </div>
      ) : (
        <YoutubeEmbed title="" defaultIframe={true} id={videoId} />
      )}
    </div>
  );
}
